import gql from 'graphql-tag';

export const SEARCH_QUERY = gql`
  query search(
    $query: String,
    $page: Int,
    $index: SearchType,
    $searchSort: SearchSort,
    $tagIds: [String],
    $tagSlug: String,
    $postTypes: [String]
    $authorSlug: String,
    $limit: Int,
    $includeEngagement: Boolean,
  ) {
    search(
      query: $query,
      page: $page,
      index: $index,
      sort: $searchSort,
      tagIds: $tagIds,
      tagSlug: $tagSlug,
      postTypes: $postTypes,
      authorSlug: $authorSlug,
      limit: $limit,
      includeEngagement: $includeEngagement,
    ) {
      searchResults {
        id
        title
        name
        slug
        type
        content
        excerpt
        body
        date
        permalink
        wordCount
        crossPublishedSites
        originalSite
        engagement {
          answerDescription
          ctaLink
          ctaText
          id
          question
          type
          imageUrl
          date
        }
        author {
          id
          username
          avatar {
            thumb
          }
        }
        featuredMedia {
          url
          alt
          name
          urlMedium
          urlPostThumbnail
        }
        tags {
          id
          name
        }
        isFeatured
        lastActiveAt
        commentCount
      }
      dataLayer
      total
      tagIds
    }
  }
`;

export const GET_TRENDING_TOPICS = gql`
query trendingTopics($forumLimit: Int, $storyLimit: Int) {
  trendingTopics(forumLimit: $forumLimit, storyLimit: $storyLimit) {
    forums {
      id
      commentCount
      name
      body
      slug
      date
      tags {
        id
        name
      }
    }
    stories {
      id
      commentCount
      title
      excerpt
      content
      slug
      date
      type
      author {
        id
        username
        avatar {
          thumb
        }
      }
    }
  }
}
`;
